/**
 * aerobis cart shipping text + leftover free-ship-line.
 * Persistent asset: Impact AJAX cart/drawer section HTML does not execute
 * inline <script> tags, so this file lives once on the page and repaints
 * every .cart-shipping-text / .free-ship-line after cart:change / cart:refresh
 * / section swap.
 * Cart context: remaining amount + progress fill when below the gate;
 * full bar + unlocked copy when reached. Hide the widget when gate is 0.
 * Header announcement slides stay in the DOM across autoplay (visibility
 * only); MutationObserver still repaints if a slide is swapped in.
 */
(function () {
  if (window.aerobisFreeShipLine) return;

  var lastCartCents = null;
  var lastChangeAt = 0;
  var timers = [];

  function shopifyCurrency() {
    return (window.Shopify && Shopify.currency) || {};
  }

  function money(amount, currency) {
    var whole = Math.round(amount);
    if (currency === "EUR") {
      var fmt = (window.themeVariables && themeVariables.settings && themeVariables.settings.moneyFormat) || "";
      if (fmt) {
        return fmt
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, String(whole))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(whole))
          .replace(/\{\{\s*amount\s*\}\}/g, whole.toFixed(2));
      }
      return whole + "\u20ac";
    }
    try {
      return new Intl.NumberFormat((window.Shopify && Shopify.locale) || undefined, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(whole);
    } catch (e) {
      return whole + " " + currency;
    }
  }

  function centsFromCart(cart) {
    if (!cart || cart.total_price == null) return null;
    var n = parseInt(cart.total_price, 10);
    return isNaN(n) ? null : n;
  }

  function resolveRate(el) {
    var shopifyCur = shopifyCurrency();
    var rate = parseFloat(shopifyCur.rate);
    var active = shopifyCur.active || "";
    var currency = active || el.getAttribute("data-fs-currency") || "EUR";
    var useRate = rate;
    if (!(useRate > 0)) {
      if (currency === "EUR") useRate = 1;
      else return null;
    }
    if (currency !== "EUR" && useRate === 1) return null;
    return { useRate: useRate, currency: currency };
  }

  function isReached(cartCents, gateEur, useRate) {
    if (!(gateEur > 0) || !(useRate > 0)) return false;
    var useCents = parseInt(cartCents, 10);
    if (isNaN(useCents)) useCents = 0;
    return useCents / 100 / useRate + 1e-9 >= gateEur;
  }

  function progressPercent(cartCents, gateEur, useRate) {
    if (!(gateEur > 0) || !(useRate > 0)) return 0;
    var useCents = parseInt(cartCents, 10);
    if (isNaN(useCents) || useCents < 0) useCents = 0;
    var pct = (useCents / 100 / useRate / gateEur) * 100;
    if (pct < 0) pct = 0;
    if (pct > 100) pct = 100;
    return pct;
  }

  function hideProgress(wrap) {
    if (!wrap) return;
    wrap.setAttribute("hidden", "");
    wrap.classList.remove("is-unlocked");
    var fill = wrap.querySelector(".free-ship-progress__fill");
    var track = wrap.querySelector(".free-ship-progress__track");
    var mark = wrap.querySelector('[data-fs-mark="ship"]');
    if (mark) mark.classList.remove("is-lit");
    if (fill) fill.style.width = "0%";
    if (track) {
      track.setAttribute("aria-valuenow", "0");
      track.removeAttribute("aria-valuetext");
      track.removeAttribute("aria-label");
    }
  }

  function paintProgress(el, pct, label, unlocked) {
    var wrap = el.closest ? el.closest(".free-ship-progress") : null;
    if (!wrap) return;
    if (pct < 0) pct = 0;
    if (pct > 100) pct = 100;
    var rounded = Math.round(pct);
    var fill = wrap.querySelector(".free-ship-progress__fill");
    var track = wrap.querySelector(".free-ship-progress__track");
    if (fill) fill.style.width = pct + "%";
    if (track) {
      track.setAttribute("aria-valuenow", String(rounded));
      if (label) {
        track.setAttribute("aria-valuetext", label);
        track.setAttribute("aria-label", label);
      }
    }
    wrap.classList.toggle("is-unlocked", !!unlocked);
    var mark = wrap.querySelector('[data-fs-mark="ship"]');
    if (mark) mark.classList.toggle("is-lit", !!unlocked);
    wrap.removeAttribute("hidden");
  }

  function hideFreeShipLine(el) {
    el.textContent = "";
    el.setAttribute("hidden", "");
    el.setAttribute("data-fs-ready", "1");
    hideProgress(el.closest ? el.closest(".free-ship-progress") : null);
  }

  function hideHeaderSlide(el) {
    var slide = el.closest ? el.closest("p") : el.parentNode;
    if (slide && slide.setAttribute) slide.setAttribute("hidden", "");
    else if (el.parentNode) el.parentNode.removeChild(el);
  }

  function paintShippingText(el, cartCents) {
    el.setAttribute("data-fs-ready", "1");
    var checkout = el.getAttribute("data-fs-checkout") || "";
    var unlocked = el.getAttribute("data-fs-unlocked") || "";
    var gateEur = parseFloat(el.getAttribute("data-fs-gate-eur") || "0");
    if (!gateEur) {
      el.innerHTML = checkout;
      return;
    }
    var resolved = resolveRate(el);
    if (!resolved) {
      el.innerHTML = checkout;
      return;
    }
    var useCents = cartCents;
    if (useCents == null) useCents = parseInt(el.getAttribute("data-fs-cart-cents") || "0", 10);
    if (isNaN(useCents)) useCents = 0;
    el.setAttribute("data-fs-cart-cents", String(useCents));
    if (isReached(useCents, gateEur, resolved.useRate)) {
      if (unlocked && !/[.!?。！？]$/.test(unlocked.trim())) unlocked += ".";
      el.textContent = unlocked;
    } else {
      el.innerHTML = checkout;
      var vis = (el.textContent || "").trim();
      if (vis && !/[.!?。！？]$/.test(vis)) el.appendChild(document.createTextNode("."));
    }
  }

  function paint(el, cartCents) {
    el.setAttribute("data-fs-ready", "1");
    var context = el.getAttribute("data-fs-context") || "pdp";
    if (context === "cart") {
      var gateEur = parseFloat(el.getAttribute("data-fs-gate-eur") || "0");
      var resolved = resolveRate(el);
      var useCents = cartCents;
      if (useCents == null) useCents = parseInt(el.getAttribute("data-fs-cart-cents") || "0", 10);
      if (isNaN(useCents)) useCents = 0;
      if (!gateEur || !resolved) {
        hideFreeShipLine(el);
        return;
      }
      var reached = isReached(useCents, gateEur, resolved.useRate);
      var pct = progressPercent(useCents, gateEur, resolved.useRate);
      var lineText = "";
      if (reached) {
        lineText = el.getAttribute("data-fs-unlocked") || "";
      } else {
        var remainEur = gateEur - useCents / 100 / resolved.useRate;
        if (remainEur < 0) remainEur = 0;
        var tmpl = el.getAttribute("data-fs-remaining") || "Noch __AMT__!";
        lineText = tmpl.replace(/__AMT__/g, money(remainEur * resolved.useRate, resolved.currency));
        lineText = lineText.replace(/[.!?。！？]+\s*$/, "");
        lineText += "!";
      }
      el.textContent = lineText;
      el.removeAttribute("hidden");
      paintProgress(el, pct, lineText, reached);
      return;
    }
    var gateEur = parseFloat(el.getAttribute("data-fs-gate-eur") || "0");
    if (!gateEur) {
      if (context === "header") hideHeaderSlide(el);
      else if (el.parentNode) el.parentNode.removeChild(el);
      return;
    }
    var resolved = resolveRate(el);
    if (!resolved) {
      if (context === "header") hideHeaderSlide(el);
      else if (el.parentNode) el.parentNode.removeChild(el);
      return;
    }
    // header / pdp / any non-cart: static "from" threshold in presentment currency
    var tmplFrom = el.getAttribute("data-fs-from") || "__AMT__";
    el.textContent = tmplFrom.replace(/__AMT__/g, money(gateEur * resolved.useRate, resolved.currency));
    el.removeAttribute("hidden");
  }

  function refresh(cart) {
    var cents = centsFromCart(cart);
    if (cents != null) lastCartCents = cents;
    var shipping = document.querySelectorAll(".cart-shipping-text");
    for (var s = 0; s < shipping.length; s++) {
      var shipEl = shipping[s];
      shipEl.removeAttribute("data-fs-ready");
      var shipCents = lastCartCents;
      if (shipCents == null) shipCents = parseInt(shipEl.getAttribute("data-fs-cart-cents") || "0", 10);
      paintShippingText(shipEl, shipCents);
    }
    var nodes = document.querySelectorAll(".free-ship-line");
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      el.removeAttribute("data-fs-ready");
      var useCents = lastCartCents;
      if (useCents == null) useCents = parseInt(el.getAttribute("data-fs-cart-cents") || "0", 10);
      paint(el, useCents);
    }
  }

  function clearTimers() {
    for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
    timers = [];
  }

  function scheduleRefresh(cart) {
    refresh(cart);
    clearTimers();
    // CartDrawer replaces footer in the same cart:change turn; paint again after swap.
    timers.push(setTimeout(function () { refresh(cart); }, 0));
    timers.push(setTimeout(function () { refresh(cart); }, 60));
    timers.push(setTimeout(function () { refresh(cart); }, 1300));
  }

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  function refreshFromServer() {
    return fetch(cartRoot() + "cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) { scheduleRefresh(cart); return cart; })
      .catch(function () { scheduleRefresh(null); });
  }

  function onCartChange(event) {
    lastChangeAt = Date.now();
    var cart = event && event.detail && event.detail.cart;
    scheduleRefresh(cart);
  }

  function onCartRefresh() {
    refreshFromServer();
  }

  document.addEventListener("cart:change", onCartChange);
  document.addEventListener("cart:refresh", onCartRefresh);
  document.addEventListener("cart:updated", onCartChange);

  if (typeof window.fetch === "function") {
    var origFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = "";
      if (typeof input === "string") url = input;
      else if (input && typeof input.url === "string") url = input.url;
      return origFetch.apply(this, arguments).then(function (res) {
        if (/\/cart\/(add|change|update)/.test(url)) {
          setTimeout(function () {
            if (Date.now() - lastChangeAt > 400) refreshFromServer();
          }, 160);
        }
        return res;
      });
    };
  }

  if (window.MutationObserver) {
    var mo = new MutationObserver(function (mutations) {
      var found = false;
      for (var i = 0; i < mutations.length && !found; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if ((n.classList && (n.classList.contains("free-ship-line") || n.classList.contains("cart-shipping-text") || n.classList.contains("free-ship-progress"))) ||
              (n.querySelector && (n.querySelector(".free-ship-line") || n.querySelector(".cart-shipping-text") || n.querySelector(".free-ship-progress")))) {
            found = true;
            break;
          }
        }
      }
      if (found) {
        scheduleRefresh(lastCartCents != null ? { total_price: lastCartCents } : null);
      }
    });
    var startMo = function () {
      if (document.documentElement) {
        mo.observe(document.documentElement, { childList: true, subtree: true });
      }
    };
    if (document.documentElement) startMo();
    else document.addEventListener("DOMContentLoaded", startMo);
  }

  function boot() {
    refresh(null);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.aerobisFreeShipLine = {
    refresh: refresh,
    refreshFromServer: refreshFromServer,
    isReached: isReached,
    progressPercent: progressPercent,
    paintShippingText: paintShippingText
  };
})();
